module.exports = __webpack_public_path__ + "static/media/03.0083f49d.jpg";